import { EmptyStateInfoCombinedProps } from './types';

const usePresenter = (props: EmptyStateInfoCombinedProps): EmptyStateInfoCombinedProps => {
  return {
    ...props,
  };
};

export default usePresenter;
